import { useContext } from "react";

import "./SupervisorHome.css";

import Header from "../header/Header";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import TaskSummary from "../supervisor_home/task-summary/TaskSummary";
import AddUser from "../supervisor_home/AddUser";
import RecentEntries from "../supervisor_home/recent/RecentEntries";
import RegisterForm from "./RegisterForm";

import FormProvider from "../../context/FormContext";

const SupervisorHome = () => {
  const { isFormOpen } = useContext(FormProvider);

  return (
    <div
      className={
        isFormOpen ? "main-form-container" : "main-supervisor-container"
      }
    >
      <Header />
      <Sidebar />

      {isFormOpen ? (
        <RegisterForm />
      ) : (
        <>
          <TaskSummary />
          <AddUser />
          <RecentEntries />
        </>
      )}
    </div>
  );
};

export default SupervisorHome;
